<template>
  <div class="question-wrap">
    <div class="timer">答题用时{{ formattedTime }}</div>

    <Swipe :show-indicators="false" :touchable="false" ref="swiper">
      <SwipeItem v-for="(item, index) in questions" :key="index">
        <qusestionItem
          :question="item"
          :index="index"
          :max-length="questions.length"
          v-on:finish="onFinish"
          v-on:next="goNext"
        ></qusestionItem>
      </SwipeItem>
    </Swipe>
  </div>
</template>

<script>
import { getQuestions } from "./questionList";

import qusestionItem from "./questionItem";

import { Swipe, SwipeItem } from "vant";
export default {
  components: { Swipe, SwipeItem, qusestionItem },
  data() {
    return {
      questions: getQuestions(5),
    };
  },
  created() {},
  computed: {
    formattedTime() {
      let s = parseInt(this.time),
        h = 0,
        m = 0;

      if (s >= 60) {
        m = parseInt(s / 60);
        s = parseInt(s % 60);
        if (m > 60) {
          h = parseInt(m / 60);
          m = parseInt(m % 60);
        }
      }
      // 补零
      let zero = function (v) {
        return v >> 0 < 10 ? "0" + v : v;
      };
      return [zero(h), zero(m), zero(s)].join(":");
    },
  },
  props: ["time"],
  methods: {
    goNext(payload) {
      this.$refs["swiper"].next();
      this.$emit("record-result", payload);
    },
    onFinish(payload) {
      this.$emit("record-result", payload);
      this.$emit("finish");
    },
  },
};
</script>

<style lang="scss" scoped>
.van-swipe-item {
  background-color: #fff;
  padding: 30px;
  border-radius: 5px;
}
.timer{
    text-align: right;
    font-size: 4vw;
    color: #fbe8a9;
    margin-bottom: 10px;
}
</style>